
export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Cuidado Humanizado en el que Puede Confiar
            </h3>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              En URI, creemos que la atención médica de calidad debe ser accesible, humanizado y adaptada a las necesidades únicas de cada individuo. Con más de 15 años de experiencia, nuestro equipo de profesionales de salud certificados se dedica a proporcionar cuidado excepcional que mejora la calidad de vida de nuestros pacientes.
            </p>
            <p className="text-base text-gray-600 mb-8 leading-relaxed">
              Ya sea que necesite cuidado residencial en casa o asistencia profesional en entornos hospitalarios, nuestros servicios integrales están diseñados para apoyarlo a usted y a sus seres queridos en cada paso del camino de la atención médica. Combinamos experiencia médica con compasión genuina para brindar cuidado que realmente hace la diferencia.
            </p>
            
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-uri-green/10 rounded-xl p-5">
                <div className="w-12 h-12 bg-uri-green rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-award-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold text-2xl text-gray-900 mb-1">15+</h4>
                <p className="text-sm text-gray-600">Años de Excelencia</p>
              </div>
              <div className="bg-uri-teal/10 rounded-xl p-5">
                <div className="w-12 h-12 bg-uri-teal rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-team-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold text-2xl text-gray-900 mb-1">200+</h4>
                <p className="text-sm text-gray-600">Cuidadores Certificados</p>
              </div>
              <div className="bg-uri-blue/10 rounded-xl p-5">
                <div className="w-12 h-12 bg-uri-blue rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-user-heart-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold text-2xl text-gray-900 mb-1">5,000+</h4>
                <p className="text-sm text-gray-600">Pacientes Atendidos</p>
              </div>
              <div className="bg-uri-green-light/10 rounded-xl p-5">
                <div className="w-12 h-12 bg-uri-green-light rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-star-fill text-2xl text-white"></i>
                </div>
                <h4 className="font-bold text-2xl text-gray-900 mb-1">4.9/5</h4>
                <p className="text-sm text-gray-600">Satisfacción del Paciente</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative w-full h-full">
              <img 
                src="https://static.readdy.ai/image/f384832b5a766ad07a1721f0b33de73e/28f2726c37ab1a519483ff12c036ae2b.jpeg"
                alt="Equipo profesional de salud URI"
                className="w-full rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
                <div className="flex items-center gap-3 mb-2">
                  <i className="ri-shield-check-line text-3xl text-uri-teal"></i>
                  <div>
                    <h5 className="font-bold text-gray-900 text-base">Totalmente Certificados</h5>
                    <p className="text-xs text-gray-600">Licenciados y Asegurados</p>
                  </div>
                </div>
                <p className="text-xs text-gray-600">Todos nuestros cuidadores son profesionales certificados con amplia capacitación y verificación de antecedentes.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Why Choose URI */}
        <div className="bg-gradient-to-br from-uri-teal to-uri-teal-dark rounded-3xl p-12 text-white">
          <div className="text-center mb-12">
            <h3 className="text-3xl md:text-4xl font-bold mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              ¿Por Qué Elegir URI?
            </h3>
            <p className="text-lg text-white/80 max-w-2xl mx-auto">
              Vamos más allá del cuidado básico para proporcionar apoyo integral que aborda todos los aspectos del bienestar del paciente
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-pulse-line text-3xl text-white"></i>
              </div>
              <h4 className="font-bold text-xl mb-3">Planes de Cuidado Personalizados</h4>
              <p className="text-sm text-white/80 leading-relaxed">
                Cada paciente recibe un plan de cuidado personalizado adaptado a sus necesidades médicas específicas, preferencias y requisitos de estilo de vida.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-24-hours-line text-3xl text-white"></i>
              </div>
              <h4 className="font-bold text-xl mb-3">Disponibilidad 24/7</h4>
              <p className="text-sm text-white/80 leading-relaxed">
                Nuestro equipo está disponible las 24 horas del día para proporcionar cuidado, responder preguntas y responder a emergencias cuando nos necesite.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-3xl text-white"></i>
              </div>
              <h4 className="font-bold text-xl mb-3">Profesionales Expertos</h4>
              <p className="text-sm text-white/80 leading-relaxed">
                Nuestros cuidadores certificados se someten a capacitación rigurosa y educación continua para proporcionar el más alto estándar de cuidado.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
